import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLegalProfessional = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 4.5H14C14 4.5 15 4.5 15 5.5V13.5C15 13.5 15 14.5 14 14.5H2C2 14.5 1 14.5 1 13.5V5.5C1 5.5 1 4.5 2 4.5Z",
			fill: "#A4A7E4",
			fillOpacity: .25,
			stroke: "#A4A7E4",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.228 2.18333C10.1616 1.98431 10.0342 1.81122 9.86393 1.68858C9.69368 1.56595 9.48916 1.49997 9.27933 1.5H6.72067C6.51084 1.49997 6.30632 1.56595 6.13607 1.68858C5.96581 1.81122 5.83844 1.98431 5.772 2.18333L5 4.5H11L10.228 2.18333Z",
			stroke: "#A4A7E4",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 1.13672,
			y1: 8.88599,
			x2: 14.8633,
			y2: 8.88599,
			stroke: "#A4A7E4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.74402 6.66821V9.16528C9.74402 10.1286 8.96317 10.9094 7.99988 10.9094C7.03661 10.9094 6.25574 10.1286 6.25574 9.16528V6.66821H9.74402Z",
			fill: "#E8E9F8",
			stroke: "#A4A7E4"
		})
	] })
});
export default SvgLegalProfessional;
